<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"/>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="4" v-if="mostrarCompleto">
            <b-form-group align="left">
              <label>Fecha inicio: </label>
              <b-input-group size="sm" class="mb-2" id="fci" lab>
                <b-form-datepicker name="nombre" placeholder="Fecha de Inicio"
                                   no-flip
                                   v-model="$v.filtro.fechaInicio.$model"
                                   :state="validateState('fechaInicio')"
                ></b-form-datepicker>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="4" v-if="mostrarCompleto">
            <b-form-group align="left">
              <label>Fecha fin: </label>
              <b-input-group size="sm" class="mb-2" id="fcf" lab>
                <b-form-datepicker name="nombre" placeholder="Fecha de Fin"
                                   :min="filtro.fechaInicio"
                                   :max="new Date()"
                                   v-model="$v.filtro.fechaFin.$model"
                                   :state="validateState('fechaFin')"

                ></b-form-datepicker>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="1" v-if="mostrarCompleto"><br/>
            <b-button block variant="outline-primary" @click="llenarTabla">
              <font-awesome-icon icon="search" v-b-popover.hover.top="'Buscar datos en bandeja'"/>
            </b-button>
          </b-col>
          <b-col align="right" cols="3" v-if="!mostrarCompleto"><br/>
            <b-button block variant="outline-primary" v-if="$localStorageService.can('IC_01_intercons_crear')"
                      type="submit"
                      @click="llamarModalSolicitud()"
            >Generar solicitud
            </b-button>
          </b-col>
          <b-col align="right" cols="3" v-if="!mostrarCompleto"><br/>
            <b-button block variant="outline-primary" @click="llenarTabla">
              <font-awesome-icon icon="sync" v-b-popover.hover.top="'Actualizar bandeja'"/> Actualizar
            </b-button>
          </b-col>
        </b-row>

        <br/>

        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab :title="'Pendientes (' + datosTablaPendiente.length +')'" v-if="$localStorageService.can('IC_01_intercosulta_pendiente')">
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTablaPendiente"
                :fields="fieldsPendientes"
                :per-page="$registrosPorPaginaTabla"
                :current-page="paginaActualPendientes"
                responsive
            >
              <template v-slot:cell(detalle)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="verDetalle(row.item)"
                >
                  <b-icon icon="info-circle"></b-icon
                  >
                </b-button>
              </template>

              <template v-slot:cell(contestar)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="contestar(row.item)"
                >
                  <b-icon icon="pencil-square"></b-icon
                  >
                </b-button>
              </template>

            </b-table>

            <b-pagination
                v-if="datosTablaPendiente !== undefined && datosTablaPendiente.length > 10"
                align="center"
                v-model="paginaActualPendientes"
                :total-rows="datosTablaPendiente.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tablaPendientes"
            ></b-pagination>
            <div style="margin-top: 150px"></div>
          </b-tab>
          <b-tab :title="'En Proceso (' + datosTablaProceso.length +')'" v-if="$localStorageService.can('IC_01_intercosulta_contestar')">
            <b-table
                id="EnProceso"
                thead-tr-class="columnas"
                :items="datosTablaProceso"
                :fields="fieldsProceso"
                :per-page="$registrosPorPaginaTabla"
                :current-page="paginaActualProceso"
                responsive
            >
              <template v-slot:cell(detalle)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="verDetalle(row.item)"
                >
                  <b-icon icon="info-circle"></b-icon
                  >
                </b-button>
              </template>

              <template v-slot:cell(contestar)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="contestar(row.item)"
                >
                  <b-icon icon="pencil-square"></b-icon
                  >
                </b-button>
              </template>
            </b-table>

            <b-pagination
                v-if="datosTablaProceso !== undefined && datosTablaProceso.length > 10"
                align="center"
                v-model="paginaActualProceso"
                :total-rows="datosTablaProceso.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tablaProceso"
            ></b-pagination>
            <div style="margin-top: 150px"></div>
          </b-tab>
          <b-tab :title="'Finalizado (' + datosTablaFinalizado.length +')'" v-if="$localStorageService.can('IC_01_intercosulta_descargar')">
            <b-table
                id="Finalizado"
                thead-tr-class="columnas"
                :items="datosTablaFinalizado"
                :fields="fieldsFinalizado"
                :per-page="$registrosPorPaginaTabla"
                :current-page="paginaActualFinalizado"
                responsive
            >
              <template v-slot:cell(detalle)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="verDetalle(row.item)"
                >
                  <b-icon icon="info-circle"></b-icon
                  >
                </b-button>
              </template>

              <template v-slot:cell(contestar)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="contestar(row.item)"
                >
                  <b-icon icon="pencil-square"></b-icon
                  >
                </b-button>
              </template>

              <template v-slot:cell(descargar)="row">
                <b-button
                    size="sm"
                    variant="outline-warning"
                    v-on:click="descargarPDF(row.item)"
                >
                  <b-icon icon="printer"></b-icon
                  >
                </b-button>
              </template>


            </b-table>

            <b-pagination
                v-if="datosTablaFinalizado !== undefined && datosTablaFinalizado.length > 10"
                align="center"
                v-model="paginaActualFinalizado"
                :total-rows="datosTablaFinalizado.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tablaFinalizado"
            ></b-pagination>
            <div style="margin-top: 150px"></div>
          </b-tab>
        </b-tabs>

      </b-col>
    </b-row>
    <br/> <br/><br/> <br/>

    <b-modal
        v-model="mostrarModalForm"
        size="lg"
        title="Solicitud-Recepción de Interconsulta Odontológica"
        scrollable
        :no-close-on-backdrop="true">
      <InterconsultaFormulario ref="modalFormulario"
                               v-if="mostrarModalForm"
                               :idEmpleadoRegistro="$localStorageService.getIdEmpleado()"
                               :nombreUsuarioRegistro="$localStorageService.getNombreCompletoUsuario()"
                               :idClinicaRegistro="$localStorageService.getIdClinica()"
                               :idPacienteRegistro="Number($route.params.id)"
                               :esRegistroNuevo="true"
                               :esRespuesta="false"
                               @actualizarLoadingGuardar="actualizarLoadingGuardar"
                               @mostrarModalRegistrar="mostrarModalRegistrar"
      />
      <div slot="modal-footer">
        <b-button
            style="margin: 5px"
            variant="outline-primary"
            @click="$refs.modalFormulario.$refs.submitGuardar.click()"
            :disabled="guardando"
        ><span v-if="!guardando">Guardar</span>
          <span v-if="guardando">
            <b-spinner small></b-spinner>
            Guardando...
          </span>
        </b-button>
        <b-button
            :disabled="guardando"
            style="margin: 5px"
            variant="outline-danger"
            @click="() => {mostrarModalForm = false}"
        >Cancelar
        </b-button
        >
      </div>

    </b-modal>

    <b-modal
        v-model="mostrarModalConsultar"
        size="lg"
        title="Detalle de Solicitud-Recepción de Interconsulta Odontológica"
        scrollable
        :no-close-on-backdrop="false">
      <InterconsultaFormulario ref="modalFormularioConsultar"
                               v-if="mostrarModalConsultar"
                               :esRegistroNuevo="false"
                               :esRespuesta="false"
                               :esConsulta="true"
                               :itemEdit="itemEdit"
      />
      <div slot="modal-footer">
        <b-button
            :disabled="guardando"
            style="margin: 5px"
            variant="outline-danger"
            @click="() => {mostrarModalConsultar = false}"
        >Cerrar
        </b-button>
      </div>

    </b-modal>

    <b-modal
        v-model="mostrarModalFormContestar"
        size="lg"
        title="Contestar Solicitud-Recepción de Interconsulta Odontológica"
        scrollable
        :no-close-on-backdrop="true">
      <InterconsultaFormulario ref="modalFormularioContestar"
                               v-if="mostrarModalFormContestar"
                               :itemEdit="itemEdit"
                               :esRegistroNuevo="false"
                               :esRespuesta="true"
                               @actualizarLoadingGuardar="actualizarLoadingGuardar"
                               @mostrarModalRegistrar="mostrarModalRegistrar"
                               @mostrarModalContestar="mostrarModalContestar"
      />
      <div slot="modal-footer">
        <b-button
            style="margin: 5px"
            variant="outline-primary"
            @click="$refs.modalFormularioContestar.$refs.submitGuardar.click()"
            :disabled="guardando"
        ><span v-if="!guardando">Guardar</span>
          <span v-if="guardando">
            <b-spinner small></b-spinner>
            Guardando...
          </span>
        </b-button>
        <b-button
            :disabled="guardando"
            style="margin: 5px"
            variant="outline-danger"
            @click="() => {mostrarModalFormContestar = false}"
        >Cancelar
        </b-button
        >
      </div>

    </b-modal>


  </div>
</template>

<script>
import InterconsultaFormulario from "./InterconsultaFormulario";
import {required} from "vuelidate/lib/validators";

export default {
  name: "BandejaInterconsulta",
  components: {
    InterconsultaFormulario,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading: false,
    guardando: false,
    imprimiendo: false,
    paginaActual: 1,
    mostrarModalForm: false,
    mostrarModalConsultar: false,
    mostrarModalFormContestar: false,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
      idPaciente: null
    },
    datosTablaPendiente: [],
    datosTablaProceso: [],
    datosTablaFinalizado: [],

    paginaActualPendientes: 1,
    paginaActualProceso: 1,
    paginaActualFinalizado: 1,

    fields: [],
    fieldsPendientes: [],
    fieldsProceso: [],
    fieldsFinalizado: [],

    itemEdit: null,

    tabIndex: 0,
  }),
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  props: {
    idPaciente: Number
  },
  computed: {
    mostrarCompleto() {
      return this.idPaciente === undefined || this.idPaciente === null || this.idPaciente <= 0
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.filtro.idPaciente = this.idPaciente;

    if (!this.mostrarCompleto) {
      this.fields = [
        {
          key: 'idInterconsulta',
          label: 'ID',
          sortable: true
        },
        {
          key: 'nombreEmpleadoConsulta',
          label: 'Odontólogo que solicita',
          sortable: true
        },
        {
          key: 'nombreEmpleadoResponde',
          label: 'Odontólogo interconsultante',
          sortable: true
        }
      ]
    } else {
      this.fields = [
        {
          key: 'idInterconsulta',
          label: 'ID',
          sortable: true
        },
        {
          key: 'idPaciente',
          label: 'ID Paciente',
          sortable: true
        },
        {
          key: 'nombrePaciente',
          label: 'Paciente',
          sortable: true
        },
        {
          key: 'nombreEmpleadoConsulta',
          label: 'Odontólogo que solicita',
          sortable: true
        },
        {
          key: 'nombreEmpleadoResponde',
          label: 'Odontólogo interconsultante',
          sortable: true
        }
      ]
    }

    this.fields.push({
      key: "fechaInterconsulta",
      label: "Fecha interconsulta",
      formatter: this.$formatoFechaHora
    });

    this.fields.push({
      key: "fechaContestacion",
      label: "Fecha contestación",
      formatter: this.$formatoFechaHora
    });

    this.fields.push({
      key: 'detalle',
      label: 'Ver detalle'
    })

    this.fieldsPendientes = [...this.fields];
    this.fieldsProceso = [...this.fields];
    this.fieldsFinalizado = [...this.fields];

    this.fieldsPendientes.push({
      key: 'contestar',
      label: 'Contestar'
    })

    this.fieldsProceso.push({
      key: 'contestar',
      label: 'Contestar'
    })

    this.fieldsFinalizado.push({
      key: 'descargar',
      label: 'Descargar'
    });

    this.filtro.fechaInicio = new Date();
    this.filtro.fechaFin = new Date();
    this.llenarTabla();
  },
  methods: {
    llamarModalSolicitud() {
      this.mostrarModalForm = true;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
    llenarTabla() {

      this.datosTablaPendiente = [];
      this.datosTablaProceso = [];
      this.datosTablaFinalizado = [];

      const datosFiltro = {
        fechaInicio: this.$moment(this.filtro.fechaInicio).set({
          "hour": 0,
          "minute": 0,
          "second": 0,
          "millisecond": 0
        }).utc(),
        fechaFin: this.$moment(this.filtro.fechaFin).set({
          "hour": 0,
          "minute": 0,
          "second": 0,
          "millisecond": 0
        }).add(1, 'days').utc(),
        idPaciente: this.filtro.idPaciente,
        busquedaPorPacienteLog: !this.mostrarCompleto
      }

      this.loading = true;
      this.$http
          .post(this.$api + "interconsulta/obtenerDatos", datosFiltro)
          .then((response) => {
            if (response.status === 200 && response.data.data !== null) {
              this.datosTablaPendiente = response.data.data.filter(it => it.idEstatus === 1);
              this.datosTablaProceso = response.data.data.filter(it => it.idEstatus === 2);
              this.datosTablaFinalizado = response.data.data.filter(it => it.idEstatus === 3);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    actualizarLoadingGuardar(guardando) {
      this.guardando = guardando;
    },
    mostrarModalRegistrar(mostrar) {
      this.guardando = false;
      this.mostrarModalForm = mostrar;
      if (!mostrar) {
        this.llenarTabla();
      }
    },
    mostrarModalContestar(mostrar) {
      this.guardando = false;
      this.mostrarModalFormContestar = mostrar;
      if (!mostrar) {
        this.llenarTabla();
        this.tabIndex = 2;
      }
    },

    verDetalle(item) {
      this.itemEdit = item;
      this.mostrarModalConsultar = true;
    },
    contestar(item) {
      this.itemEdit = item;

        const parametros = {
          idInterconsulta: this.itemEdit.idInterconsulta
        }

      this.$http
          .put(this.$api + "interconsulta/actualizarInterconsultaEnProceso", parametros)
          .then(() => {

            const indiceObjExisteEnProceso = this.datosTablaProceso.findIndex(it=>it.idInterconsulta === this.itemEdit.idInterconsulta);
            if (indiceObjExisteEnProceso < 0) {
              this.itemEdit.idEstatus = 2;
              this.datosTablaProceso.push(this.itemEdit);
              this.tabIndex = 1;
            }

            const indiceObjExistePendiente = this.datosTablaPendiente.findIndex(it=>it.idInterconsulta === this.itemEdit.idInterconsulta);
            if (indiceObjExistePendiente >= 0) {
              this.datosTablaPendiente.splice(indiceObjExistePendiente, 1);
            }

            this.mostrarModalFormContestar = true;
          });
    },

    async descargarPDF(item) {
      this.itemEdit = item;
      this.pdf = null;
      const url =
          this.$api + "interconsulta/descargarInterConsulta";
      const modal = await this.lanzarModalConfirmacion(
          "¿Deseas imprimir la interconsulta?"
      );

      if (modal.isConfirmed) {
        this.imprimiendo = true;
        const parametros = {idInterconsulta: this.itemEdit.idInterconsulta}
        this.$http
            .post(url, parametros)
            .then((respuesta) => {
              this.imprimiendo = false;

              const byteCharacters = atob(respuesta.data.data);
              const byteArrays = [];

              for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
              }

              const blob = new Blob(byteArrays, {type: 'application/pdf'});

              const url = window.URL.createObjectURL(blob);
              // window.open(url);
              const link = document.createElement('a');
              link.href = url;
              link.download = "interconsulta"+this.itemEdit.idInterconsulta+".pdf";
              link.click();

            })
            .catch((error) => {
              this.imprimiendo = false;

              if (error.response) {
                this.lanzarModalInformacion(
                    "Aviso",
                    "error",
                    error.response.data.message
                );
              }
            });
      }
    },

    lanzarModalInformacion(titulo, icono, cuerpoMensaje) {
      this.$swal.fire({
        icon: icono,
        title: titulo,
        text: cuerpoMensaje,
      });
    },

    async lanzarModalConfirmacion(titulo) {
      return await this.$swal.fire({
        title: titulo,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
      });
    },
  },

}
</script>

<style scoped>

</style>
